export enum TokenProtocol {
	NATIVE = "NATIVE",
	ERC20 = "ERC20",
	ERC1155 = "ERC1155",
	ERC721 = "ERC721",
}
